var _path, _ellipse, _ellipse2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscordBig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5C15.4123 17.1489 13.7152 17.4883 12 17.5C10.2848 17.4883 8.58773 17.1489 7 16.5",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.333,
    cy: 11.6675,
    rx: 1.5,
    ry: 1.75,
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.6665,
    cy: 11.6675,
    rx: 1.5,
    ry: 1.75,
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30222 16.951C7.83725 18.016 7.27644 19.0365 6.6267 20C5.05745 19.503 3.565 18.79 2.1923 17.8815H2.19415C1.55487 13.6513 2.4907 9.33361 4.82406 5.74769C6.15811 5.16098 7.55975 4.74189 8.9969 4.5C9.10236 4.85075 9.18713 5.20991 9.27176 5.56913C10.1739 5.42237 11.0859 5.34524 11.9999 5.33842C12.9139 5.34524 13.8259 5.42237 14.728 5.56913C14.8127 5.20991 14.8974 4.85075 15.0029 4.5C16.4401 4.74189 17.8417 5.16098 19.1757 5.74769C21.5091 9.33361 22.4449 13.6513 21.8057 17.8815H21.8075C20.4348 18.79 18.9424 19.503 17.3731 20C16.7234 19.0365 16.1626 18.016 15.6976 16.951",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordBig);
export default __webpack_public_path__ + "static/media/discord-big.f0de2f66f8ce20065b4e8403127e5062.svg";
export { ForwardRef as ReactComponent };